import config from ".";

export const BASE_URL = config.endpointURL.URL;
console.log("env",process.env)
console.log("REACT_APP_BASEURL_DEV",process.env.REACT_APP_BASEURL_DEV)
console.log("redirect uri",process.env.REACT_APP_AAD_APP_REDIRECT_URI);
// MILISECONDS
export const CONFIG_SAVE_OVERVIEW_STAFFING_SECONDS = 300000; // 5 min
